/**
 * Header.class
 *
 * Handling of page header.
 *
 * (c) notwenidges übel UG, Dimitri Preiß (preiss@notwenidges-uebel.de)
 */

const youtubeIframe = '<iframe '
    + 'width="560" '
    + 'height="315" '
    + 'src="https://www.youtube-nocookie.com/embed/###id###?rel=0&autoplay=1" '
    + 'title="YouTube video player" '
    + 'frameborder="0" '
    + 'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" '
    + 'allowfullscreen></iframe>';

const html5Player = '<video '
    + 'controls '
    + 'playsinline '
    + 'preload="metadata"'
    + ' height="220" '
    + 'width="390" '
    + 'poster="###poster###">\n'
    + '    <source src="###video###" type="video/mp4">\n'
    + '</video>';

const cookieAllow = '<div class="allow-youtube-cookies m-auto">'
    + '<h2 class="delimiter">Wir brauchen Ihr Einverständnis</h2>'
    + '<p>Zum Einbinden des Videos nutzen wir Drittanbieter. Diese können persönliche Daten über '
    + 'Ihre Aktivitäten sammeln. <br>Bitte bestätigen Sie, dass sie damit einverstanden sind.</p>'
    + '<p><a href="###gdprlink###" target="_blank">Mehr erfahren Sie in unserer Datenschutzerklärung.</a></p>'
    + '<button class="modal-allow-cookies btn btn-primary">Video laden</button>'
    + '</div>';

export default class Video {
    config = {
        modalId: 'videoModal',
        modalContent: '.modal-content',
        openVideo: '.video-modal-open',
    };

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.init();
    }

    init() {
        if (document.querySelectorAll(this.config.openVideo).length > 0) {
            const modal = document.createElement('div');

            modal.id = 'videoModal';
            modal.classList.add('modal');
            modal.innerHTML = '<div class="modal-close close-icon" aria-label="Close">'
                + '<span></span><span></span></div><div class="modal-content text-center"></div>';

            document.body.appendChild(modal);

            this.$modal = document.getElementById(this.config.modalId);
            this.$modal.content = this.$modal.querySelector(this.config.modalContent);

            if (window.klaro) {
                this.ConsentManager = window.klaro.getManager(window.klaroConfig);
            }

            this.registerEvent();
        }
    }

    registerEvent() {
        document.querySelectorAll(this.config.openVideo).forEach((elem) => {
            elem.addEventListener('click', (e) => {
                this.clickOpenHandler(e);
            });
        });

        this.$modal.querySelectorAll('.modal-close').forEach((elem) => {
            elem.addEventListener('click', () => {
                this.hideModal();
            });
        });

        // Backdrop-Click schließt das Modal
        this.$modal.addEventListener('click', (e) => {
            if (e.target === this.$modal) {
                this.hideModal();
            }
        });

        // Escape-Taste schließt das Modal
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.$modal.classList.contains('show')) {
                this.hideModal();
            }
        });
    }

    showModal() {
        this.$modal.classList.add('show');
        document.body.classList.add('modal-is-active');
    }

    hideModal() {
        this.$modal.classList.remove('show');
        document.body.classList.remove('modal-is-active');
        this.$modal.content.innerHTML = '';
    }

    appendYoutubeVideoToModal(id, gdprlink) {
        if (this.ConsentManager.states.youtube === true) {
            this.showYoutubeVideo(id);
        } else {
            this.appendCookie(id, gdprlink);
        }
    }

    appendHTML5VideoToModal(video, poster) {
        this.$modal.content.innerHTML = html5Player.replace('###video###', video)
            .replace('###poster###', poster);
    }

    allowCookiesClickHandler(id) {
        this.ConsentManager.updateConsent('youtube', true);
        this.ConsentManager.saveAndApplyConsents();

        this.showYoutubeVideo(id);
    }

    appendCookie(id, gdprlink) {
        this.$modal.content.innerHTML = cookieAllow.replace('###gdprlink###', gdprlink);
        this.$modal.content.querySelector('.modal-allow-cookies').addEventListener('click', () => {
            this.allowCookiesClickHandler(id);
        });
    }

    clickOpenHandler(e) {
        const data = e.currentTarget.dataset;

        if (data.type === 'inline' && data.src.length > 0) {
            this.appendHTML5VideoToModal(data.src, data.poster);
            this.showModal();
        }

        if (data.type === 'youtube' && data.src.length > 0) {
            this.appendYoutubeVideoToModal(data.src, data.gdprlink);
            this.showModal();
        }
    }

    showYoutubeVideo(id) {
        this.$modal.content.innerHTML = youtubeIframe.replace('###id###', id);
        this.showModal();
    }
}
